import { passCodes } from '../passCodes';

export const step16riddle = {
    id: 16,
    title: 'Vyšetřování',
    taskText: `
        <p>
            Odpovězte správně na všechny otázky a procvičte si mysl.
        </p>
    `,
    cipher: {
        text: `
            <p>
                Kolik je tu odpadkových košů?
            </p>
            <ol type="a">
                <li>1</li>
                <li>2</li>
                <li>3</li>
            </ol>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[4],
    additionalInfo: 'Odpovědí je písmeno a/b/c',
    points: false,
    hints: [
        {
            text: 'Koše jsou 3',
        },
    ],
};
